import ModalDeleteFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'

const ModalDeleteQuoteComment: React.FC<ModalEditComponentProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/order/quote/comment/deleteQuoteOrderComment',
        data: allRowData || {}
    })

    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteComment', '¿Seguro que quieres borrar este comentario?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminada no podrás recuperarlo'),
            buttonAccept: t('delete', 'Borrar'),
            buttonCancel: t('return', 'Volver')
        }} />
    )
}

export default ModalDeleteQuoteComment